import { createElement } from 'react';

import {
  createFrontendPlugin,
  PageBlueprint,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import InsightsIcon from '@mui/icons-material/Insights';

import { rootRouteRef } from './routes';

const engineeringInsightsPage = PageBlueprint.make({
  name: 'engineering-insights',
  params: {
    path: '/engineering-insights',
    title: 'Insights',
    icon: createElement(InsightsIcon),
    loader: async () => {
      const { OrganisationHomePage } = await import(
        './components/pages/HomePage/OrganisationHomePage'
      );
      return createElement(OrganisationHomePage);
    },
  },
});

const engineeringInsightsEntityTab = EntityContentBlueprint.make({
  name: 'engineering-insights-entity',
  params: {
    path: '/engineering-insights',
    title: 'Engineering Insights',
    filter: 'kind:group',
    routeRef: rootRouteRef,
    loader: async () => {
      const { HomePage } = await import('./components/pages/HomePage/HomePage');
      return createElement(HomePage);
    },
  },
});

const engineeringInsightsRepositoryTab = EntityContentBlueprint.make({
  name: 'engineering-insights-repository',
  params: {
    path: '/engineering-insights',
    title: 'Engineering Insights',
    filter: 'kind:repository',
    loader: async () => {
      const { RepositoryHomePage } = await import(
        './components/pages/HomePage/RepositoryHomePage'
      );
      return createElement(RepositoryHomePage);
    },
  },
});

export const engineeringInsightsPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'engineering-insights-frontend',
  extensions: [
    engineeringInsightsPage,
    engineeringInsightsEntityTab,
    engineeringInsightsRepositoryTab,
  ],
  routes: {
    root: rootRouteRef,
  },
});
